import { useWindowResize } from "helpers/utility/utilities";
import { RefObject, useEffect, useRef } from "react";
import { createPortal } from "react-dom";

import styles from "./style.module.scss";

interface TextTooltipProps {
  text: string;
  parentRef: RefObject<HTMLElement>;
}

const TextTooltip = ({ text, parentRef }: TextTooltipProps) => {
  const tooltipRef = useRef<HTMLDivElement>(null);
  const width = useWindowResize();

  useEffect(() => {
    const parent = parentRef.current;
    const tooltip = tooltipRef.current;
    if (parent && tooltip) {
      const parentRect = parent.getBoundingClientRect();
      const tooltipRect = parent.getBoundingClientRect();
      let pTop = parentRect.top;
      let pLeft = parentRect.right;
      let pHeight = parentRect.height;
      let tWidth = tooltipRect.width;
      const viewportWidth = window.innerWidth;

      tooltip.style.setProperty("--tooltip-top", `${pTop}px`);
      tooltip.style.setProperty("--tooltip-left", `${pLeft}px`);

      if (pLeft + tWidth > viewportWidth) {
        tooltip.style.setProperty("--tooltip-top", `${pTop + pHeight}px`);
        tooltip.classList.add(styles.topTip);
      }
      tooltip.style.visibility = "visible";
    }
  }, [text, parentRef, width]);

  const tooltipEl = (
    <div className={styles.textTooltipWrapper} ref={tooltipRef}>
      <div className={styles.textTooltip}>
        <div className={styles.content}>{text}</div>
      </div>
    </div>
  );

  // Render tooltip in portal (outside normal component tree)
  const tooltipRoot = document.getElementById("tooltip-root");
  return tooltipRoot ? createPortal(tooltipEl, tooltipRoot) : null;
};

export default TextTooltip;
